import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { campaigns, products, brands } from "data/actions";
import MenuLink from "components/Navigation/MenuLink";

import { Page, PageBlock, RightDrawer } from "components/Page";
import Price from "components/Formaters/Price";
import Delete from "components/Buttons/Delete";
import * as os from "osutil";

import Subheader from "material-ui/Subheader";
import RaisedButton from "material-ui/RaisedButton";

class CampaignsPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchProducts();
    this.props.actions.fetchCampaigns(this.props.user.accountid);
  }

  handleDeleteClick(id) {
    this.props.actions.deleteCampaign(this.props.user.accountid, id);
  }

  handleEditClick = id => {
    this.context.router.history.push("/kampanj/" + id);
  };

  addCampaign(e) {
    this.props.actions.createCampaign(
      this.props.user.accountid,
      {
        created: new Date().getTime(),
        updated: new Date().getTime(),
        status: "draft",
        name: "New campaign"
      },
      this.handleEditClick
    );
  }

  renderCampaigns = campaigns => {
    if (!campaigns || campaigns.length === 0) {
      return <span className="campaign_empty">Inga kampanjer</span>;
    }

    return _.map(campaigns, (campaign, key) => {
      var count = campaign.bookings ? Object.keys(campaign.bookings).length : 0;
      var amount = campaign.details.amount ? campaign.details.amount : 0;
      return (
        <div
          className="campaigns_row"
          key={key}
          onClick={this.handleEditClick.bind(this, campaign.key)}
        >
          <span className="campaign_row_name">{campaign.details.name}</span>
          <span className="campaign_row_">{count} annonser</span>
          <span className="campaign_row_">
            <Price value={amount} />
          </span>
          <span className="campaign_row_actions">
            {campaign.details.status === "draft" && (
              <Delete
                handleClick={this.handleDeleteClick.bind(this, campaign.key)}
              />
            )}
          </span>
        </div>
      );
    });
  };
  render() {
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Kampanjer">
          <RaisedButton onClick={e => this.addCampaign()}>
            Skapa ny
          </RaisedButton>
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <PageBlock label="Planerade kampanjer" header={true} className="campaigns_list">
          {this.renderCampaigns(this.props.draft)}
        </PageBlock>

        <PageBlock label="Bokade kampanjer" header={true} className="campaigns_list">
          {this.renderCampaigns(this.props.booked)}
        </PageBlock>

        <PageBlock label="Bekräftade kampanjer" header={true} className="campaigns_list">
          {this.renderCampaigns(this.props.confirmed)}
        </PageBlock>

        <PageBlock label="Genomförda kampanjer" header={true} className="campaigns_list">
          {this.renderCampaigns(this.props.completed)}
        </PageBlock>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  if (!state.products.list.data) {
    return {};
  }
  var list = os.collection_to_array(state.campaigns.list.data);
  return {
    campaigns: list,
    draft: _.filter(list, c => c.details.status === "draft"),
    booked: _.filter(list, c => c.details.status === "booked"),
    confirmed: _.filter(list, c => c.details.status === "confirmed"),
    completed: _.filter(list, c => c.details.status === "completed"),
    products: state.products.list.data,
    user: state.auth.user,
    pending: state.campaigns.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...products, ...campaigns, ...brands },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(CampaignsPage);



// WEBPACK FOOTER //
// ./src/pages/campaigns/Campaigns.jsx